import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

/**
 * A fun dialog that appears when the user hits the API rate limit (429 error).
 * Shows a tiger emoji and a friendly message asking them to slow down.
 */
const RateLimitDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{ zIndex: 1500 }} // System dialog — always visible above any other dialog
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: "center",
          overflow: "hidden",
        },
      }}
    >
      {/* Fun graphic/icon at the top */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
          py: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "3.5rem !important",
            lineHeight: 1,
            filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.2))",
            animation: "bolt-flash 0.6s ease-in-out infinite",
            "@keyframes bolt-flash": {
              "0%, 100%": { opacity: 0.6 },
              "50%": { opacity: 1 },
            },
          }}
        >
          ⚡
        </Typography>
        <Typography
          sx={{
            fontSize: "4rem !important",
            lineHeight: 1,
            filter: "drop-shadow(4px 4px 8px rgba(0,0,0,0.3))",
          }}
        >
          🐯
        </Typography>
        <Typography
          sx={{
            fontSize: "3.5rem !important",
            lineHeight: 1,
            filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.2))",
            animation: "bolt-flash 0.6s ease-in-out infinite",
            "@keyframes bolt-flash": {
              "0%, 100%": { opacity: 0.6 },
              "50%": { opacity: 1 },
            },
          }}
        >
          ⚡
        </Typography>
      </Box>

      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "1.5rem",
          pt: 3,
          pb: 1,
        }}
      >
        Woah! Slow down tiger!
      </DialogTitle>

      <DialogContent sx={{ pb: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Our servers have detected you are going a little too fast for us. Your
          action hasn't completed. Please try again in a few minutes.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            borderRadius: 2,
            px: 4,
            background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
            "&:hover": {
              background: "linear-gradient(135deg, #f57c00 0%, #ef6c00 100%)",
            },
          }}
        >
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RateLimitDialog;
